module.exports = __webpack_public_path__ + "static/media/creativity.f103ccb1.svg";